import React from "react";
import styled from "styled-components";
import { Card } from "../../";
const StyledCard = styled(Card)`
  height: ${p => p.theme.heightCardMd};
  min-height: ${p => p.theme.heightCardMd};
  max-height: ${p => p.theme.heightCardMd};
`;

const Wrapper = ({
  children,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(StyledCard, rest, children);
};

export default Wrapper;